import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewChild,
  signal,
} from '@angular/core';
import { ModalService } from '../state/modal.service';

@Component({
  selector: 'fini-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: false,
})
export class ModalComponent implements OnInit {
  @Input() relative = false;
  @Input() canClose = true;
  @Output() closed = new EventEmitter<boolean>();
  @ViewChild('content') elementRef: ElementRef;

  active = signal(false);

  constructor(
    private el: ElementRef,
    private state: ModalService,
  ) {}

  ngOnInit(): void {
    setTimeout(() => {
      this.state.attach(this.elementRef);
      this.active.set(true);
    }, 0);
  }

  @HostListener('document:mousedown', ['$event.target'])
  public onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target);
    if (
      !clickedInside &&
      this.closed.observed &&
      this.state.isClosable(this.elementRef)
    ) {
      if (this.canClose) {
        this.active.set(false);
      }
      setTimeout(() => {
        this.closed.emit(true);
        this.state.detach(this.elementRef);
      }, 250);
    }
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler() {
    if (
      this.active() &&
      this.closed.observed &&
      this.state.isClosable(this.elementRef)
    ) {
      if (this.canClose) {
        this.active.set(false);
      }
      setTimeout(() => {
        this.closed.emit(true);
        this.state.detach(this.elementRef);
      }, 250);
    }
  }
}
